import React from "react";
import ScrollToTop from "./ScrollToTop";
import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from "./Layout";
import Home from "../pages/home/Home";
import Faq from "../pages/faq/Faq";
import Contact from "../pages/contact/Contact";
import Error from "../pages/404/Error";
import Thankyou from "../pages/thankyou/Thankyou";
import TermsConditions from "../pages/TermsAndcConditions/TermsConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import Blog from "../pages/Blog/Blog";
import Healthcare from "../pages/Industries/Healthcare/Healthcare";
import Hospitality from "../pages/Industries/Hospitality/Hospitality";
import Commercial from "../pages/Industries/Commercial/Commercial";
import Textile from "../pages/Industries/Textile/Textile";
import Education from "../pages/Industries/Education/Education";
import Pharma from "../pages/Industries/Pharma/Pharma";
import Railways from "../pages/Industries/Railways/Railways";
import Defence from "../pages/Industries/Defence/Defence";
import Landromart from "../pages/Industries/Landromart/Landromart";
import About from "../pages/About/About";
import ProjectListing from "../pages/Project/ProjectListing";
import ProjectDetail from "../pages/ProjectDetail/ProjectDetail";
import News from "../pages/News/News";
import NewsDetail from "../pages/NewsDetail/NewsDetail";
import BlogDetails from "../pages/BlogDetails/BlogDetails";
import Career from "../pages/career/Career";
import ProductListing from "../pages/Product/ProductListing/ProductListing";
import ProductDetail from "../pages/Product/ProductMainDetail/ProductMainDetail";
import ProductDetails from "../pages/Product/ProductDetails/ProductDetails";
import ProductMainDetail from "../pages/Product/ProductMainDetail/ProductMainDetail";
import Training from "../pages/Services/Training/Training";
import ServiceOn from "../pages/Services/service/ServiceOn";
import ProjectPlaning from "../pages/Services/ProjectPlaning/ProjectPlaning";
import Logistics from "../pages/Services/Logistics/Logistics";
import Installation from "../pages/Services/Installation/Installation";
import EnquiryPopup from "../components/EnquiryPopup";
import { useModal } from "../contexts/ModalContext";
import DynamicPage from "../pages/DynamicPage/DynamicPage";

function Redirect({ to }) {
  if (typeof window !== "undefined") {
    // client-side
    return <Navigate to={to} replace />;
  }
  return null; // SSR just renders nothing
}


export default function NavRouter({ initialData }) {
  const { modalShow, closeQueryModal } = useModal();
  return (
    <>
      <ScrollToTop />
      <EnquiryPopup show={modalShow} setShow={closeQueryModal} />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home initialData={initialData} />} />
          <Route path="about" element={<About />} />
          <Route path="faq" element={<Faq />} />
          <Route path="contact" element={<Contact />} />
          <Route path="terms-condition" element={<TermsConditions />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />

          {/* blog */}
          <Route path="blog" element={<Blog initialData={initialData} />} />
          <Route path="blog/:slug" element={<BlogDetails initialData={initialData} />} />
   
          {/* project */}
          <Route path="project" element={<ProjectListing initialData={initialData} />} />
          <Route path="project/:slug" element={<ProjectDetail initialData={initialData} />} />

          {/* news */}
          <Route path="news" element={<News initialData={initialData} />} />
          <Route path="news/:slug" element={<NewsDetail initialData={initialData} />} />

          {/* product */}
          <Route path="product-listing" element={<ProductListing initialData={initialData} />} />
          <Route path="product-listing/:slug" element={<ProductDetails initialData={initialData} />} />
          <Route path="product/:product_detail_slug" element={<ProductMainDetail initialData={initialData} />} />

          {/* dynamic page */}
          <Route path="dynamic-page/:dynamic_slug" element={<DynamicPage initialData={initialData} />} />

          {/* industries */}
          <Route path="heathcare-medical-grade-commercial-laundry" element={<Healthcare initialData={initialData} />} />
          <Route path="hospitality-laundry-washing-machine-system" element={<Hospitality initialData={initialData} />} />
          <Route path="commercial-laundry-washing-machine" element={<Commercial initialData={initialData} />} />
          <Route path="commercial-laundry-for-garment-manufacturing" element={<Textile initialData={initialData} />} />
          <Route path="commercial-washing-machine-for-university" element={<Education initialData={initialData} />} />
          <Route path="pharmaceutical-grade-commercial-laundry" element={<Pharma initialData={initialData} />} />
          <Route path="railway-grade-commercial-laundry-machine" element={<Railways initialData={initialData} />} />
          <Route path="defence-grade-commercial-laundry-machine" element={<Defence initialData={initialData} />} />
          <Route path="industrial-laundromat-washing-machines" element={<Landromart initialData={initialData} />} />
          <Route path="careers" element={<Career />} />

          {/* Services */}
          <Route path="training" element={<Training />} />
          <Route path="sales-service" element={<ServiceOn />} />
          <Route path="project-planing" element={<ProjectPlaning />} />
          <Route path="delivery" element={<Logistics />} />
          <Route path="installation" element={<Installation />} />

        </Route>

        {/* {Route without footer} */}
        <Route element={<Layout footerHide="footer-hider" />}>
          <Route path='/404' element={<Error />} />
          <Route path="*" element={<Redirect to="/404" />} />
          <Route path="thank-you" element={<Thankyou />} />
        </Route>
      </Routes>
    </>
  );
}
